export default ['us', 'gb', 'de', 'es', 'fr', 'it', 'br']
